import React from 'react'
import styled from '@emotion/styled'
import {ListItem} from 'semantic-ui-react'
import {H6} from '@styles/Global.styles'
import theme from '@styles/theme'
import darkTheme from '@styles/dark-theme'

export const ColorOptionsContainer = styled.div`
`

export const ColorListItem = styled(({card, ...props}) => <ListItem {...props} />)`
    padding: 0 !important;
    padding-top: 0.21428571em !important;
    &&&&{
        margin-left: 0;
        margin-right: ${props => props.isMobile ? '12px' : (props.card ? '4px' : '8px')} ;
    }
    &:last-child {
        margin-right: 0 !important;
    }
`

export const ColorItem = styled(({card, selected,color, enabled, darkTheme, ...rest})=> <div {...rest}/>)`
    &&&&{
        box-shadow: ${props=>props.color.toString().toLowerCase().includes('#fff') ? (props.darkTheme ? '' : '0 0 1px 1px #ddd') : ''};
        width: ${props=>props.card === false ? '46px' : '20px'};
        height: ${props=>props.card === false ? '46px' : '20px'};
        border: ${props => props.selected ? 'solid ' : (props.darkTheme ? 'solid' : 'none')};
        border-width: ${props =>props.selected ? (props.card === false ? '2px' : '2px') : (props.darkTheme ? '2px' : '0px')};
        border-color:${props => props.darkTheme ? (props.selected ? 'white' : (props.color.toString().toLowerCase().includes('#000') ? '#707070' : props.color)) : (props.color.toString().toLowerCase().includes('#fff') ? '#707070' : props.color)};
        content: '';
        border-radius: ${props => props.card === false ? '8px': '4px'};
        ${props=>props.color.length === 2 ? !props.selected ?
            `background: linear-gradient(45deg, ${props.color[0]} 0 50%, ${props.color[1]} 50% 100%);` :
            `background-color: ${props.selected ? theme.brand.colors.white : props.color};` :
            `background-color: ${props.color.length === 2 ? '#fff' : props.selected ? (props.darkTheme ? '#000' : '#fff') : props.color};`
        }
        cursor: ${props=>props.enabled && 'pointer' };
        &:after{
            box-shadow: ${props=>props.color.toString().toLowerCase().includes('#fff') ? (props.darkTheme ? '' : '0 0 1px 1px #ddd') : ''};

            ${props=>props.color.length === 2 ?
                `background: linear-gradient(45deg, ${props.color[0]} 0 50%, ${props.color[1]} 50% 100%);` :
                `background-color: ${props.color};`
            }
            content:'';
            display: ${props=>props.selected ? 'block' : 'none'};
            position: relative;
            border-radius: ${props=>props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '6px' : '5px') : '1px'};

            top: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px') : '2px'};
            left: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            height: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '42px' : '38px'): '12px'};
            width: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '42px' : '38px'): '12px'};
            bottom: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            right: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            border:${props => !props.card && props.color.length === 2 && props.selected && props.darkTheme ? '#000 2px solid' : (!props.card && props.color.toString().toLowerCase().includes('#000') && props.selected && props.darkTheme ? 'white 2px solid' :  '') };
        }
    }

`

export const ColorItemMobile = styled(({card, selected,color, enabled, darkTheme, ...rest})=> <div {...rest}/>)`
    &&&&{
        box-shadow: ${props=>props.color.toString().toLowerCase().includes('#fff') ? (props.darkTheme ? '' : '0 0 1px 1px #ddd') : ''};
        width: ${props=>props.card === false ? '46px' : '20px'};
        height: ${props=>props.card === false ? '46px' : '20px'};
        border: ${props => props.selected ? 'solid ' : (props.darkTheme ? 'solid' : 'none')};
        border-width: ${props =>props.selected ? (props.card === false ? '2px' : '2px') : (props.darkTheme ? '2px' : '0px')};
        border-color:${props => props.darkTheme ? (props.selected ? 'white' : (props.color.toString().toLowerCase().includes('#000') ? '#707070' : props.color)) : (props.color.toString().toLowerCase().includes('#fff') ? '#707070' : props.color)};
        content: '';
        border-radius: ${props => props.card === false ? '8px': '4px'};
        ${props=>props.color.length === 2 ? !props.selected ?
            `background: linear-gradient(45deg, ${props.color[0]} 0 50%, ${props.color[1]} 50% 100%);` :
            `background-color: ${props.selected ? theme.brand.colors.white : props.color};` :
            `background-color: ${props.color.length === 2 ? '#fff' : props.selected ? (props.darkTheme ? '#000' : '#fff') : props.color};`
        }
        cursor: ${props=>props.enabled && 'pointer' };
        &:after{
            box-shadow: ${props=>props.color.toString().toLowerCase().includes('#fff') ? (props.darkTheme ? '' : '0 0 1px 1px #ddd') : ''};

            ${props=>props.color.length === 2 ?
                `background: linear-gradient(45deg, ${props.color[0]} 0 50%, ${props.color[1]} 50% 100%);` :
                `background-color: ${props.color};`
            }
            content:'';
            display: ${props=>props.selected ? 'block' : 'none'};
            position: relative;
            border-radius: ${props=>props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '6px' : '5px') : '1px'};

            top: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px') : '2px'};
            left: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            height: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '42px' : '38px'): '12px'};
            width: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '42px' : '38px'): '12px'};
            bottom: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            right: ${props => props.card === false ? (props.color.length === 2 && props.selected && props.darkTheme ? '0px' : '2px'): '2px'};
            border:${props => !props.card && props.color.length === 2 && props.selected && props.darkTheme ? '#000 2px solid' : (!props.card && props.color.toString().toLowerCase().includes('#000') && props.selected && props.darkTheme ? 'white 2px solid' :  '') };
        }
    }

`

export const PaletteHeading = styled.div`
    display: block;
    clear: both;
    margin-bottom: 8px;
    margin-top: 20px;
`

export const PaletteTitle = styled(({darkTheme, ...rest}) => <H6 {...rest}/>)`
    float: left;
    margin-bottom: 0;
    color: ${props => props.darkTheme ? 'white' : '#707070'} ;
`

export const PaletteSelection = styled(({darkTheme, ...rest}) => <span {...rest} />)`
    text-align: left;
    font-size: 16px;
    font-weight: light;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: ${props => props.darkTheme ? 'white' : '#707070'} ;
    padding-left: 6px;
`

export const PlateColorPaletteContainer = styled.div`
    display: block;
    clear: both;
`
